import { Button, Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { CheckmarkIcon, CurrencyBalanceIcon } from 'BreetAssets';
import { Amount } from 'BreetComponents';
import { type CURRENCYCODETYPE, CURRENCYCONFIG, getSafeObjectField } from 'BreetHelpers';

export const CurrencyBalance = ({
	currency,
	balance,
	onClick,
	className,
	isSelected,
	componentType = 'default',
}: {
	currency: CURRENCYCODETYPE;
	balance: string;
	onClick?: () => void;
	isSelected?: boolean;
	className?: string;
	componentType?: 'default' | 'balance';
}) => (
	<Button
		variant='native'
		className={classNameMerger(
			'currency-balance-component theme-background-none',
			!isSelected && 'non-selected border-dark-navy',
			className,
			componentType,
			componentType === 'balance' && 'button-cancel-transform'
		)}
		type='button'
		onClick={onClick}
	>
		<Typography>{currency} Wallet</Typography>
		<Typography as='h5'>
			{getSafeObjectField(CURRENCYCONFIG, currency)?.symbol} <Amount>{balance}</Amount>
		</Typography>

		<CurrencyBalanceIcon
			variant={currency}
			className='currency-balance-svg-icon svg-dark svg-dark-outline'
		/>

		{isSelected && componentType === 'default' && (
			<CheckmarkIcon
				variant='wallet'
				className='currency-checkmark'
			/>
		)}
	</Button>
);
